const GenerateButton = ({ loadingCircle, handleGenerate, disabled }) => {
  const isDisabled = loadingCircle || disabled;
  
  return (
    <button
      onClick={handleGenerate}
      disabled={isDisabled}
      className={`flex-1 bg-gradient-to-r from-purple-500 to-indigo-500 text-white font-semibold py-2 lg:py-3 px-4 lg:px-6 rounded-lg shadow-lg transition-all duration-300 text-sm lg:text-base relative overflow-hidden ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-xl hover:scale-[1.02] hover:from-purple-600 hover:to-indigo-600 active:scale-95'}`}
    >
      <span className="relative z-10 flex items-center justify-center">
        {loadingCircle ? (
          <>
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Generating...
          </>
        ) : (
          "Generate"
        )}
      </span>
    </button>
  );
};

export default GenerateButton; 